import { useQuery } from '@tanstack/react-query';

import { fetchSaldo, type SaldoResponse } from '../api/balance.api';

const FIVE_MINUTES = 1000 * 60 * 5;

/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 */
export function useBalanceQuery(idCuenta: string | undefined) {
  return useQuery<SaldoResponse, Error>({
    queryKey: ['balance', idCuenta],
    queryFn: () => fetchSaldo(idCuenta as string),
    enabled: !!idCuenta,
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
  });
}
